import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
// import Image from "../../../assets/images/user.svg";
import MainLogo from "../../../assets/images/taxida_white.svg";
import Toggle from "../../../assets/images/icons8-hamburger-100.png";
import notify from "../../../assets/images/notifications.svg";
// import Sms from "../../../assets/images/sms.svg";
// import Setting from "../../../assets/images/setting.svg";
// import Post from "../../../assets/images/post.svg";
// import NotePad from "../../../assets/images/note-pad.svg";
import DarkLogo from "../../../assets/images/taxida_black.svg";
import "./header.scss";
import AccessControl from "../../access-control";
import NotificationPopup from "../../../containers/pricingsNew/NotificationPopUp";

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.authUser = this.props.auth.getAuthUser();
  }
  state = {
    headerClass: "dropdown-content",
    sidebarOpen: false,
    notificationbarOpen: false,
    isShaking: false,
    count: "",
    menu_class: "",
  };

  initialState() {
    return {
      driverPopup: false,
      selectedPricing: {},
    };
  }

  toggleHeaderMenu = () => {
    this.setState({
      headerClass:
        this.state.headerClass === "dropdown-content"
          ? `${this.state.headerClass} responsive`
          : "dropdown-content",
    });
  };
  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    window.addEventListener("eventName", this.handleEnquiriesEvent);
    // const savedCount = localStorage.getItem("notificationCount");
    // if (savedCount !== null) {
    //   this.setState({ count: savedCount });
    // }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
    window.removeEventListener("eventName", this.handleEnquiriesEvent);
  }

  handleEnquiriesEvent = (event) => {
    const newCount =
      event.detail && event.detail.count ? event.detail.count : "";

    this.setState({ isShaking: true, count: newCount });
    // localStorage.setItem("notificationCount", newCount);

    setTimeout(() => {
      this.setState({ isShaking: false });
    }, 2000);
  };

  setWrapperRef = (node) => {
    this.wrapperRef = node;
  };

  handleClickOutside = (e) => {
    if (this.wrapperRef && !this.wrapperRef.contains(e.target)) {
      this.setState({
        headerClass: "dropdown-content",
      });
    }
  };
  /**
   * Method is to toggle sidebar
   */
  toggleSidebar = () => {
    this.props.dispatch({
      type: "TOGGLE_SIDEBAR",
      payload: { visible: !this.props.sidebar.visible },
    });
  };
  toggleNotificationbar = () => {
    this.props.dispatch({
      type: "TOGGLE_NOTIFICATIONBAR",
      payload: {
        notificationvisible: !this.props.notificationbar.notificationvisible,
      },
    });
  };

  setToggleTopMenuClass = () => {
    if (this.state.menu_class === "") {
      this.setState({
        menu_class: "toggled",
      });
    } else {
      this.setState({
        menu_class: "",
      });
    }
  };

  showDriverPopup = () => {
    this.setState({
      driverPopup: !this.state.driverPopup,
      // driverPopup: true,
    });
  };

  hideDriverPopup = () => {
    this.setState(
      {
        driverPopup: false,
      },
      () => {
        // this.grid.getRecords();
        this.setState(this.initialState(), () => {
          // Reload the page
          // window.location.reload();
        });
      }
    );
  };

  render() {
    const userRole = this.authUser.roleId || 0;
    const {
      sidebar: { visible: isOpen },
    } = this.props;

    const { driverPopup, isShaking, count } = this.state;

    const header_menu_class = `fixed-header ${this.state.menu_class}`;
    const { firstName, lastName, email, countryCode, phone } = this.authUser;

    return (
      <div>
        <header className={header_menu_class}>
          <span
            className="main-logo main-bg"
            style={{
              display: isOpen ? "inline-flex" : "none",
              cursor: "default",
            }}
          >
            <img src={MainLogo} alt="main-logo" />
          </span>
          <span
            className="main-logo white-bg"
            style={{
              display: isOpen ? "none" : "inline-flex",
              cursor: "default",
            }}
          >
            <img src={DarkLogo} alt="main-logo" />
          </span>
          &nbsp;&nbsp;&nbsp;
          <button
            type="button"
            className={
              !this.props.sidebar.visible
                ? "pe-none toggle-menu"
                : "toggle-menu"
            }
            onClick={this.toggleSidebar}
          >
            <img src={Toggle} alt="toggle-img" className="img-ham" />
          </button>
          <ul className="anchorList a-width">
            <AccessControl section="bookings.create">
               <li>
                <button type="button" className="new-booking">
                  <Link to="/bookings/addnew">B2C booking</Link>
                </button>
              </li>
              {/* <li>
                <button type="button" className="new-booking">
                  <Link to="/bookings/add">B2C booking</Link>
                </button>
              </li> */}
              {/*<li>
                <button type="button" className="new-booking">
                  <Link to="/b2bbookings/add">B2B booking</Link>
                </button>
          </li>*/}
              <li>
                <button type="button" className="new-booking">
                  <Link to="/etsbookings/add">ETS booking</Link>
                </button>
              </li>
            </AccessControl>
          </ul>
          <ul ref={this.setWrapperRef} className="anchorList ml-auto">
            {/* <li>
              <button type="button">
                <img src={NotePad} alt="note-img" />
                <span className="badge badge-task">3</span>
              </button>
            </li>
            <li>
              <button type="button">
                <img src={Sms} alt="sms-img" />
              </button>
            </li>
            <li>
              <button type="button">
                <img src={Post} alt="post-img" />
                <span className="badge badge-mail">7</span>
              </button>
            </li> */}
            {/*<button
              type="button"
              className={
                !this.props.notificationbar.notificationvisible
                  ? "pe-none toggle-menu"
                  : "toggle-menu"
              }
              onClick={this.toggleNotificationbar}
            >
            <img src={Toggle} alt="toggle-img" />
            </button>*/}
            <li className="notify-section">
              <img
                src={notify}
                alt="notification"
                className={`notify-icon ${isShaking ? "shake" : ""}`} // Dynamically add shake class
                onClick={this.showDriverPopup}
              />
              {count ? <div className="notify-count">{count || "0"}</div> : ""}
            </li>

            {userRole === 10 ? (
              <li>
                <button
                  type="button"
                  className="drop-down"
                  onClick={this.toggleHeaderMenu}
                >
                  <span className="badge">
                    {firstName.slice(0, 1).toUpperCase()}
                  </span>
                </button>
                <div className={this.state.headerClass}>
                  <div className="dropdown-header">
                    <div>{`${firstName} ${lastName}`}</div>
                    <div>{email}</div>
                    <div>{`${countryCode} ${phone}`}</div>
                  </div>
                  <div className="dropdown-item">
                    <button
                      className="logging-out"
                      type="button"
                      onClick={this.props.auth.logout}
                    >
                      Logout
                    </button>
                  </div>
                </div>
              </li>
            ) : (
              <li>
                <button
                  className="logout yellow-focus"
                  type="button"
                  onClick={this.props.auth.logout}
                >
                  Logout
                </button>
              </li>
            )}
          </ul>
          {/* <button type="button" className="account-button">
            <img src={Setting} alt="setting-img" />
          </button>
          <button type="button" className="account-button">
            <img className="account-img" src={Image} alt="account-img" />
          </button> */}
          {driverPopup ? (
            <NotificationPopup
              showing={this.state.driverPopup}
              close={this.hideDriverPopup}
            />
          ) : (
            ""
          )}
        </header>
      </div>
    );
  }
}

export default connect((state) => {
  return {
    sidebar: state.sidebar,
    notificationbar: state.notificationbar,
  };
})(Header);
